const COLORS = {
  MEDIUM_BLUE: '#112f3c',
  LIGHT_BLUE: '#5EAFEA',
  BACKGROUND_GREY: '#e5e5e5',
  WHITE: '#ffffff',
  MEDIUM_ORANGE: '#FFB22A',
  BLACK: '#000000',
  BLACK_NEW: '#282828',
  BLACK01: '#BBBBBB',
  VERTICAL_DIVIDER: 'rgba(17, 47, 60, 0.1)',
  ADD_EXISTING_TEXT: '#203C48B2',
  TOMATO: '#FF6347',
  MEDIUM_LIGHTBLUE: '#02A9F4',
  MEDIUM_PINK: '#E04F5F',
  PALE_LIGHTBLUE: '#32BEA6',
  MEDIUM_LIGHTBLUE01: '#18a0fb',
  MEDIUM_BLUE02: 'rgba(17, 47, 60, 0.7)',
  MEDIUM_BLUE03: 'rgba(17, 47, 60, 0.5)',
  MEDIUM_BLUE04: 'rgba(17, 47, 60, 1)',
  MEDIUM_BLUE05: 'rgba(17, 47, 60, 0.4)',
  MEDIUM_BLUE06: 'rgba(17, 47, 60, 0.6)',
  DARK_GREY: '#EDEDED',
  MEDIUM_GREY: '#e5e5e5',
  LIGHT_GREY: '#d3d3d3',
  LIGHT_GREY01: '#F2F2F2',
  THICK_GREY: '#f5f5f5',
  MEDIUM_BROWN: '#EC9964',
  MEDIUM_YELLOW: 'rgba(255, 178, 42, 1)',
  DARK_GREY01: '#e8e8e8',
  VIOLET: 'linear-gradient(85.79deg, #C65583 1.18%, #EF669B 180.55%)',
  VIOLET01: '#9271BE',
  SKYBLUE: '#73CFEE',
  SKYBLUE01: '#03A9F4',
  LIGHT_PINK: '#EF669B',
  GREY: '#333333',
  GREY_10: '#4D4D4D',
  GREY_11: '#D7D7D7',
  GREY_12: '#949494',
  GREY_13: 'rgba(51, 51, 51, 0.5)',
  DARK_PINK: '#B92250',
  BAR_CHART_COLOR1: '#9271BE',
  BAR_CHART_COLOR2: '#B92250',
  BAR_CHART_COLOR3: '#EF669B',
  LINK_COLOR_DARK: '#02A9F4',
  LINK_COLOR_LIGHT: '#45E9FF',
  SKYBLUE02: '#03ACEE',
  YELLOW01: '#FF9B1B',
  LIGHT_BLUE_01: '#2A90BC',
  VIOLET02: '#43277A',
  PINK: '#EF6060',
  PINK_01: '#cf4a72',
  VERY_LIGHT_GRAY: ' #EBEBEB',
  DARK_BLUE: '#272F32',
}
export { COLORS }
